import { render, staticRenderFns } from "./VirementP2pDiac.vue?vue&type=template&id=98c0dd0c&"
import script from "./VirementP2pDiac.vue?vue&type=script&lang=js&"
export * from "./VirementP2pDiac.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VirementP2pDiac.vue"
export default component.exports